module.exports = __webpack_public_path__ + "img/feibiaoN134-1-EN.d9885696.png";